import CryptoJS from "crypto-js";

/**
 * Encrypts data using AES-256-CBC with a random IV and Base64-encoded output.
 *
 * @param {Object} payload - The object to encrypt.
 * @param {string} path - The API path string (e.g., "User/Login").
 * @param {string} base64Key - A 32-byte (256-bit) AES key in Base64 format.
 * @returns {string} - Base64 encoded encrypted string (IV + CipherText).
 */

// This is to encrypt the password before sending it to the server *API *(["AES:StringAES"])
export function encryptPassword(password) {
  // var base64Key = "sUQQgn2lUk0UfJnNQwCXadNDVtckPd/eHuXa/pxiRGo=";
  var base64Key = "a+fyZYn0fzyJDp1DjTc+WiATnTRQi2ZbVo0KJ4gXCy8=";

  if (!password) {
    throw new Error("Invalid parameters: password is required.");
  }

  // Ensure the AES key is valid
  const key = CryptoJS.enc.Base64.parse(base64Key);
  if (key.sigBytes !== 32) {
    throw new Error("AES key must be 32 bytes (256-bit)");
  }

  // Generate 16-byte IV
  const iv = CryptoJS.lib.WordArray.random(16);

  // Encrypt using AES-CBC with PKCS7 padding
  const encrypted = CryptoJS.AES.encrypt(password, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Concatenate IV + encrypted ciphertext
  const combined = iv.concat(encrypted.ciphertext);

  // Return Base64 encoded (IV + ciphertext)
  return CryptoJS.enc.Base64.stringify(combined);
}

// This is to encrypt the payload before sending it to the server *Gateway* (["AES:GatewayKey"])
export function generatePayload(payload, path) {
  // var base64Key = "C2VT3L7r5eQpA6wXq5Zxy4JnDDMKN9w2Lw+uzXYdQ90=";
  var base64Key = "o5U1suq5P7tzgPDQzqXp0wj/IJP8t6b0BA61+evtsHk=";

  if (!payload || !base64Key || !path) {
    throw new Error(
      "Invalid parameters: payload, base64Key, and path are required."
    );
  }

  // Ensure the AES key is valid
  const key = CryptoJS.enc.Base64.parse(base64Key);
  if (key.sigBytes !== 32) {
    throw new Error("AES key must be 32 bytes (256-bit)");
  }

  // Construct the full request object to be encrypted
  const jsonString = JSON.stringify({
    timestamp: new Date().toLocaleString("sv-SE", {
      timeZone: "Asia/Kuala_Lumpur",
    }),
    path: path,
    payload: payload,
  });

  // console.log("Payload to encrypt:", JSON.parse(jsonString));

  // Generate 16-byte IV
  const iv = CryptoJS.lib.WordArray.random(16);

  // Encrypt using AES-CBC with PKCS7 padding
  const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Concatenate IV + encrypted ciphertext
  const combined = iv.concat(encrypted.ciphertext);

  //  Base64 encoded (IV + ciphertext)
  const base64Encrypted = CryptoJS.enc.Base64.stringify(combined);

  // Return final JSON structure
  return {
    payloads: base64Encrypted,
  };
}
